/**
 * Angular 2 decorators and services
 */
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { environment } from "environments/environment";
import { AppState } from "../app.service";
import { TranslateService } from "@ngx-translate/core";
import { ROOT_SELECTOR } from "../crossconcern/utilities/properties/selector.property";
import { logData } from "../crossconcern/helpers/generic/generic.helper";
import { LANG_CODE_EN, LANG_CODE_FR, LANG_CODE_IT } from "../crossconcern/utilities/properties/base.property";
import { UserManager } from "../business/managers/user.manager";

/**
 * App Component
 * Top Level Component
 */
@Component({
    selector: ROOT_SELECTOR,
    encapsulation: ViewEncapsulation.None,
    templateUrl: "./app.component.html",
    styleUrls: [
        "./app.component.scss"
    ]
})
export class AppComponent implements OnInit {
    public name = "Virtual Tour";
    public showDevModule: boolean = environment.showDevModule;
    public loadingCounter = 0;
    public loading = false;

    constructor(
        public appState: AppState,
        private translate: TranslateService,
        private userManager: UserManager) {
        if (userManager.getCurrentLanguage() === undefined || userManager.getCurrentLanguage() === null
            || (userManager.getCurrentLanguage() !== LANG_CODE_EN && userManager.getCurrentLanguage() !== LANG_CODE_IT
                && userManager.getCurrentLanguage() !== LANG_CODE_FR)) {
            // this language will be used as a fallback when a translation isn't found in the current language
            translate.setDefaultLang(LANG_CODE_EN);
            // the lang to use, if the lang isn't available, it will use the current loader to get them
            logData("browser lang " + translate.getBrowserLang());
            translate.use(translate.getBrowserLang());
            this.userManager.setCurrentLanguage(translate.currentLang);
            logData(this.userManager.getCurrentLanguage());
        } else {
            translate.use(userManager.getCurrentLanguage());
        }
    }

    public ngOnInit() {
        logData("Initial App State " + this.appState.state);
    }

    public startLoading() {
        this.loadingCounter++;
        if (this.loadingCounter === 1) {
            this.updateLoader();
        }
    }

    public stopLoading() {
        this.loadingCounter--;
        if (this.loadingCounter <= 0) {
            this.loadingCounter = 0;
            this.updateLoader();
        }
    }

    private updateLoader() {
        setTimeout(() => this.loading = (this.loadingCounter >= 1));
    }
}
